import { Component, inject, Input } from "@angular/core";
import { TextareaComponent } from "@dsn/textarea/textarea.component";
import { ButtonComponent } from "@dsn/button/button.component";
import { ChipsComponent } from "@app/shared/components/dsn/chips/chips.component";
import { FormsModule } from "@angular/forms";
import { ButtonRoundedComponent } from "@dsn/button-rounded/button-rounded.component";
import { ReportEntity } from "@arch/domain/entity";
import { InsertReportFeedbackController } from "@arch/presentation/controllers/insert-report-feedback.controller";
import { DialogService } from "@app/shared/services/dialog/dialog.service";
import { EventsService } from "@arch/domain/application/services/events.service";
import { ContactService } from "@app/shared/services/contact.service";

@Component({
    selector: "app-report-feedback",
    imports: [
        TextareaComponent,
        ButtonComponent,
        ChipsComponent,
        FormsModule,
        ButtonRoundedComponent
    ],
    templateUrl: "./report-feedback.component.html",
    styleUrl: "./report-feedback.component.scss"
})
export class ReportFeedbackComponent {
    @Input({ required: true }) report: ReportEntity;

    private readonly insertReportFeedbackController = inject(
        InsertReportFeedbackController
    );
    readonly dialogService: DialogService = inject(DialogService);
    private readonly contactService = inject(ContactService);

    public contact = this.contactService.get();
    public starsSelected: number = 0;
    private readonly eventsService = inject(EventsService);
    public stars: boolean[] = [false, false, false, false, false];
    public chipItems: { label: string; selected: boolean }[] = [
        {
            label: "Resultados",
            selected: false
        },
        {
            label: "Encargos",
            selected: false
        },
        {
            label: "Gastos",
            selected: false
        },
        {
            label: "Quero marcar uma reunião",
            selected: false
        }
    ];
    public commentText: string = "";
    public isClosed = true;
    public isOpen = false;

    public selectChip(index: number): void {
        this.chipItems[index].selected = !this.chipItems[index].selected;
    }

    public selectStar(index: number): void {
        for (let i = 0; i <= index; i++) {
            this.stars[i] = true;
        }
        for (let i = index + 1; i < this.stars.length; i++) {
            this.stars[i] = false;
        }

        const selectedStars = this.stars.filter((star) => star).length;
        this.starsSelected = selectedStars;
    }

    public toggleToast(): void {
        this.isClosed = !this.isClosed;
        this.isOpen = !this.isOpen;
    }

    public async sendFeedback(): Promise<void> {
        this.eventsService.send(
            `Dash.${this.report.type}.${this.report.humanSourceName}.feedback`
        );
        const selectedStars = this.stars.filter((star) => star).length;
        this.starsSelected = selectedStars;
        const selectedChips = this.chipItems
            .filter((chip) => chip.selected)
            .map((chip) => chip.label);

        await this.insertReportFeedbackController.execute({
            _id: this.report.props._id,
            feedback: {
                score: selectedStars,
                comment: this.commentText,
                userId: this.contact.props._id,
                opinion: selectedChips,
                date: new Date().toISOString(),
                presentation: {
                    comment: this.commentText,
                    score: selectedStars.toString()
                },
                name: this.contact.props.name,
                username: this.contact.props.email,
                isContact: true
            }
        });

        this.dialogService
            .confirm(
                "Feedback enviado com sucesso!",
                "Sua mensagem foi enviada para sua contabilidade!",
                "Fechar"
            )
            .subscribe(() => {});

        this.isClosed = !this.isClosed;
        this.isOpen = !this.isOpen;
    }
}
